import React from 'react';
import { TagIcon } from 'lucide-react';
interface BrandOffersProps {
  brandSlug: string;
}
export function BrandOffers({
  brandSlug
}: BrandOffersProps) {
  const offers = [{
    id: 1,
    title: 'Buy 2 Get 1 Free',
    description: 'On selected skincare products',
    image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=700',
    color: 'from-purple-600 to-pink-600'
  }, {
    id: 2,
    title: 'Up to 40% OFF',
    description: 'Summer collection clearance',
    image: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=700',
    color: 'from-orange-600 to-red-600'
  }, {
    id: 3,
    title: 'Free Shipping',
    description: 'On orders over 200 SAR',
    image: 'https://images.unsplash.com/photo-1471864190281-a93a3070b6de?w=700',
    color: 'from-brand to-sage-dark'
  }];
  return <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1239" data-mp="3aos8g9cr8tca">
      <div className="flex items-center gap-3 mb-6" data-id="element-1240" data-mp="3an8rshn6sg9z">
        <div className="bg-[#1E2B55] bg-opacity-10 p-3 rounded-lg" data-id="element-1241" data-mp="3v0kxqom4uufq">
          <TagIcon className="w-6 h-6 text-[#1E2B55]" data-id="element-1242" data-mp="3ujuv3cbn756" />
        </div>
        <div data-id="element-1243" data-mp="3tryvretb7ed">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-1244" data-mp="3wmg7a2j4c3k">
            Special Offers
          </h2>
          <p className="text-gray-600" data-id="element-1245" data-mp="3qa4lv8xyngvh">
            Limited time deals you don't want to miss
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1246" data-mp="3ca3inmu83xcu">
        {offers.map(offer => <div key={offer.id} className="relative aspect-[14/5] overflow-hidden rounded-lg border border-gray-100 cursor-pointer group" data-id="element-1247" data-mp="3h9pw9xdyrfm6">
            <img src={offer.image} alt={offer.title} className="absolute inset-0 h-full w-full object-cover" data-id="element-1248" data-mp="37ba2fmnjxs8z" />
            <div className={`absolute inset-0 bg-gradient-to-r ${offer.color} opacity-80 group-hover:opacity-90 transition-opacity`} data-id="element-1249" data-mp="10llqsvql5pyx"></div>
            <div className="absolute inset-0 flex flex-col justify-center p-6 text-white" data-id="element-1250" data-mp="143rma80lu2pe">
              <h3 className="text-2xl font-bold mb-2" data-id="element-1251" data-mp="z3dnlgkw8541">{offer.title}</h3>
              <p className="text-white text-opacity-90" data-id="element-1252" data-mp="u4kc1tp62o6i">{offer.description}</p>
            </div>
          </div>)}
      </div>
    </div>;
}